import React from 'react'
import PropTypes from 'prop-types'
import resolveProps from '../../utils/resolveProps'

const config = {
  types: [
    {
      title: 'primary',
      isDefault: true
    },
    'secondary',
    'primaryInverse',
    'secondaryInverse',
    'global',
    'icon'
  ],
  modifiers: [
    {
      title: 'md',
      isDefault: true
    },
    'sm',
    'lg',
    'block'
  ],
  states: ['disabled']
}

export default function Button(props) {
  const {
    primary,
    secondary,
    primaryInverse,
    secondaryInverse,
    global,
    icon,
    iconName,
    md,
    sm,
    lg,
    block,
    children,
    disabled,
    data,
    href,
    target,
    gtm = {},
    ...rest
  } = props

  const TagName = href ? 'a' : 'button'
  const { gtmClassName = '', dataGTM = {} } = gtm

  return (
    <TagName
      {...rest}
      className={`${resolveProps(props, config, 'Button')} ${!!gtmClassName? gtmClassName:''}`}
      disabled={disabled}
      href={href}
      target={target}
      role={href ? 'link' : 'button'}
      aria-label={href ? 'link' : 'button'}
      {... dataGTM}

    > {icon
      ? <span className={`mdn-Icon-${iconName || 'fechar'} mdn-Icon--sm `}></span>
      : children
      }
    </TagName>
  )
}

Button.propTypes = {
  children: PropTypes.node,
  disabled: PropTypes.bool,
  icon: PropTypes.bool,
  primary: PropTypes.bool,
  secondary: PropTypes.bool,
  primaryInverse: PropTypes.bool,
  secondaryInverse: PropTypes.bool,
  global: PropTypes.bool,
  md: PropTypes.bool,
  iconName: PropTypes.string,
  sm: PropTypes.bool,
  lg: PropTypes.bool,
  block: PropTypes.bool,
  data: PropTypes.bool,
  href: PropTypes.string,
  target: PropTypes.string,
  gtm: PropTypes.object
}
